import {CardContent, CardHeader, FormHelperText} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {EditForm, TextField} from "@variocube/app-ui";
import React, {ReactNode, useEffect, useState} from "react";
import {CompartmentSettings} from "../../api";
import {useLocalization, useWordingFlavor} from "@smalox/shared";

interface CompartmentSettingsEditFormProps {
	loading: boolean;
	compartmentSettings?: CompartmentSettings;
	onSave: (compartmentSettings: CompartmentSettings) => Promise<any>;
	title?: ReactNode;
}

export function CompartmentSettingsEditForm(props: CompartmentSettingsEditFormProps) {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	const {loading, compartmentSettings, onSave, title} = props;

	const [compartmentSizes, setCompartmentSizes] = useState<string[]>([]);
	const [defaultSize, setDefaultSize] = useState("");

	useEffect(() => {
		if (compartmentSettings) {
			setCompartmentSizes(compartmentSettings.compartmentSizes);
			setDefaultSize(compartmentSettings.defaultSize ?? "");
		}
	}, [compartmentSettings]);

	async function handleSave() {
		await onSave({
			compartmentSizes,
			defaultSize,
		});
	}

	return (
		<EditForm loading={loading} labels={t} onSave={handleSave}>
			{title && <CardHeader title={title} />}
			<CardContent>
				<Autocomplete
					value={compartmentSizes}
					options={compartmentSizes}
					multiple
					freeSolo
					onChange={(_, value) => setCompartmentSizes(value)}
					fullWidth
					renderInput={props => (
						<TextField
							label={t(`settings.compartment.compartmentSizes.title.${wordingFlavor}`)}
							{...props}
						/>
					)}
				/>
				<FormHelperText>{t(`settings.compartment.compartmentSizes.helperText.${wordingFlavor}`)}</FormHelperText>
			</CardContent>
			<CardContent>
				<TextField
					label={t("settings.compartment.defaultSize.title")}
					value={defaultSize}
					onChange={setDefaultSize}
					fullWidth
				/>
				<FormHelperText>{t(`settings.compartment.defaultSize.helperText.${wordingFlavor}`)}</FormHelperText>
			</CardContent>
		</EditForm>
	);
}
